import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError, UnderReviewError } from 'src/shared/error';

import { getViewerSignature } from 'src/app/shared/api/signature';

import type { StarterDashboardV2CommentsDataQuery, StarterDashboardV2CommentsDataQueryVariables } from './api.graphql';
import { StarterDashboardV2CommentsData } from './api.graphql';

export type Petition = NonNullable<StarterDashboardV2CommentsDataQuery['petition']>;
export type StarterDashboardCommentsPageData = {
	petition: Petition;
	hasSignedPetition: boolean;
};

export async function getStarterDashboardCommentsPageData(
	utilityContext: UtilityContext,
	petitionSlug: string,
	userId: string | undefined,
): Promise<StarterDashboardCommentsPageData> {
	const { gql } = utilityContext;

	const [{ data }, signature] = await Promise.all([
		gql.fetch<StarterDashboardV2CommentsDataQuery, StarterDashboardV2CommentsDataQueryVariables>({
			query: StarterDashboardV2CommentsData,
			variables: {
				petitionSlugOrId: petitionSlug,
			},
			rejectOnError: true,
		}),
		userId ? getViewerSignature(petitionSlug, utilityContext) : Promise.resolve(undefined),
	]);

	if (!data.petition) {
		throw new NotFoundError();
	}

	if (data.petition.status === 'UNDER_REVIEW' && !data.petition.viewerCanEdit) {
		throw new UnderReviewError();
	}

	return {
		petition: data.petition,
		hasSignedPetition: !!signature,
	};
}
